var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49615 6.00228V47.9841H45.4518M1.49615 40.7808L12.855 34.1555L27.6715 42.0567L44.4639 29.216M44.4639 29.216H37.6465M44.4639 29.216L43.274 36.3632M16.4227 14.5574L8.36747 21.8067H1.62014M32.2331 10.1879C32.232 8.37603 33.7003 6.90656 35.5121 6.90619C37.3239 6.90582 38.7928 8.37469 38.7924 10.1865C38.7921 11.9984 37.3226 13.4666 35.5108 13.4655V14.5594M24.5818 12.9176C24.5819 18.9535 29.4749 23.8465 35.5108 23.8465C41.5466 23.8465 46.4397 18.9535 46.4397 12.9176C46.4397 6.88172 41.5466 1.98868 35.5108 1.98868C29.4749 1.98868 24.5818 6.88172 24.5818 12.9176ZM34.9648 18.929C34.9648 19.2305 35.2092 19.4749 35.5108 19.4749C35.8123 19.4749 36.0567 19.2305 36.0567 18.929C36.0567 18.6275 35.8123 18.383 35.5108 18.383C35.2092 18.383 34.9648 18.6275 34.9648 18.929Z",
    stroke: "#51829B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyse);
export default __webpack_public_path__ + "static/media/analyse.ee7c0845a5bfda843afe695a014fc591.svg";
export { ForwardRef as ReactComponent };